import { Injectable } from "@angular/core";

@Injectable()
export class MessageMenuService {
  getMessages(): object[] {
    return [];
  }
}
